export const TESTIMONIALS_CONTENT_PATH = 'editorial/includes/offers/multi-offer-testimonials';
